import React, { useEffect, useState } from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { Result, Button, Skeleton } from "antd";
import { gql, useLazyQuery } from "@apollo/client";
import moment from "moment-jalaali";
function UserPaymentResult(props) {
  const [paymentResult, setPaymentResult] = useState();
  const [invoiceDetails, setInvoiceDetails] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const GETINVOICEDATA = gql`
    query GetInvoce($id: ID!) {
      getInvoice(id: $id) {
        finalAmount
        paidAt
        invoiceType
      }
    }
  `;
  const [getInvoiceData, invoiceData] = useLazyQuery(GETINVOICEDATA, {
    fetchPolicy: "no-cache",
    onError(error) {
      console.log(error.message);
    },
    onCompleted(data) {
      setInvoiceDetails(data?.getInvoice);
    },
  });
  const result = searchParams.get("result");
  const invoiceId = searchParams.get("invoiceId");

  useEffect(() => {
    setPaymentResult(result);
    getInvoiceData({ variables: { id: invoiceId } });
  }, [location.pathname]);
  if (invoiceData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  if (paymentResult === "success")
    return (
      <Result
        status="success"
        title="پرداخت شما با موفقیت انجام شد."
        subTitle={
          invoiceDetails &&
          `مبلغ ${invoiceDetails?.finalAmount.toLocaleString()} ریال در تاریخ ${moment(
            invoiceDetails?.paidAt
          ).format("jYYYY/jMM/jDD")} دریافت شد.`
        }
        extra={[
          <Button type="primary" href="/dashboard" key="dashboard">
            داشبورد
          </Button>,
          <Button key="buy" href={`/invoice/${invoiceId}`}>
            فاکتور
          </Button>,
        ]}
      />
    );
  else if (true)
    return (
      <Result
        status="error"
        title="پرداخت ناموفق!"
        subTitle="در صورتی که مبلغ فاکتور از حساب شما کسر شده، حداکثر تا 72 ساعت آینده به حسابتان برخواهد گشت."
        extra={[
          <Button type="primary" href="/dashboard">
            داشبورد
          </Button>,
          <Button key="buy" href={`/invoice/${invoiceId}`}>
            پرداخت مجدد
          </Button>,
        ]}
      />
    );
}

export default UserPaymentResult;
